<template lang="pug">
  a(:href='"tel:" + number' target="_self" aria-label='"call " + number') {{ formatedPhone }}
</template>

<script>
  export default {
    name: "mrPhoneLink",
    props: {
      number: {
        type: String,
        required: true
      }
    },

    computed: {
      formatedPhone() {
        return this.number.toString().replace(/-/g, '.');
      }
    }
  }
</script>
